import { fetchFromVolatileServer } from "@/utils/fetchFromVolatileServer";
import { getUrl } from "@/utils/url";
import { Post } from "@/wp/types/client";

export async function getData(
  path: string,
  locale?: string,
  defaultLocale?: string,
): Promise<Post> {
  const pageRes = await fetchFromVolatileServer(
    `${getUrl(locale, defaultLocale)}${path}`,
  );
  return (await pageRes.json()) as Promise<Post>;
}

interface DataArray {
  code: number;
  pageData: Post[];
  headers: Headers;
}

export async function getDataArray(
  path: string,
  locale?: string,
  defaultLocale?: string,
): Promise<DataArray> {
  const pageRes = await fetchFromVolatileServer(
    `${getUrl(locale, defaultLocale)}${path}`,
  );
  const pageData = await pageRes.json();
  return { pageData, code: pageRes.status, headers: pageRes.headers };
}

export async function fetchItems<T = Post>(
  path: string,
  locale?: string,
  defaultLocale?: string,
): Promise<T[]> {
  const { pageData } = await getDataArray(path, locale, defaultLocale);
  return Array.isArray(pageData) ? (pageData as T[]) : [];
}

export async function getDataArrayGeneric<T>(
  path: string,
  lang?: string,
  defaultLang?: string,
): Promise<{
  pageData: T;
  code: number;
  headers: Headers;
}> {
  const pageRes = await fetchFromVolatileServer(
    `${getUrl(lang, defaultLang)}${path}`,
  );

  const pageData = await pageRes.json();
  return { pageData, code: pageRes.status, headers: pageRes.headers } as {
    pageData: T;
    code: number;
    headers: Headers;
  };
}
